// @flow
import * as React from 'react';

import { MobileFooterMenus } from '@ta/public.navmenus';

import styles from './MobileSeoFooterLinksContainer.less';

const compactDesign = true;

type Props = {
  breadcrumbs: any,
  mastheadH1: string,
};

const MobileSeoFooterLinks = (props: Props) => (
  <div className={styles.container}>
    <MobileFooterMenus
      breadcrumbs={props.breadcrumbs}
      headerText={props.mastheadH1}
      menus={[]}
      compactDesign={compactDesign}
    />
  </div>
);

export default MobileSeoFooterLinks;
